<template>
    <div class="inPage">
        <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
        <NavIn :inNavInfo="inNavInfo"  />
        
        <router-view></router-view>
    </div>
</template>

<script>
import BannerIn from '../../components/BannerIn/BannerIn'
import NavIn from '../../components/NavIn/NavIn'
import { getAboutInfo } from '../../api'

export default {
    data(){
        return{
            bannerUrl:'' ,
            inNavInfo:[
                {
                    title:'Company Profile',
                    url:'/about/profile',
                    selected:true
                },
                {
                    title:'company Culture',
                    url:'/about/culture',
                    selected:false
                },
                {
                    title:'Company Honor',
                    url:'/about/honor',
                    selected:false
                }
            ],
            positionInfo:{
                second:'ABOUT US',
                third:'COMPANY PROFILE'
            },
            isZhong:false
        }
    },
    components:{
        BannerIn,
        NavIn
    },
    async created(){
        const language = this.$cookies.get('language');
        let isZhong;
        if(language==="zhong"){
            isZhong = true;
        }else{
            isZhong = false;
        }
        this.isZhong = isZhong;
        let inNavInfo = [];
        let positionInfo = {};
        if(isZhong){
            inNavInfo=[
                {
                    title:'公司简介',
                    url:'/about/profile',
                    selected:true
                },
                {
                    title:'企业文化',
                    url:'/about/culture',
                    selected:false
                },
                {
                    title:'荣誉资质',
                    url:'/about/honor',
                    selected:false
                }
            ];
            positionInfo={
                second:'关于我们',
                third:''
            }
        }else{
            inNavInfo=[
                {
                    title:'Company Profile',
                    url:'/about/profile',
                    selected:true
                },
                {
                    title:'company Culture',
                    url:'/about/culture',
                    selected:false
                },
                {
                    title:'Company Honor',
                    url:'/about/honor',
                    selected:false
                }
            ];
            positionInfo={
                second:'ABOUT US',
                third:''
            }
        }
        this.inNavInfo = inNavInfo;
        this.positionInfo = positionInfo;


       //bannerIn
       const res = await getAboutInfo();
       this.bannerUrl = res.data.pic;
    },
    // 监听,当路由发生变化的时候执行
    beforeRouteUpdate  (to, from, next) {
      let currentPath = to.path;
      let inNavInfo = this.inNavInfo;
      inNavInfo.forEach(v=>v.url===currentPath?v.selected=true:v.selected=false);
      next();
    },
   
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/About/About.vue